import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DevicesService } from 'src/app/_services/devices.service';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { OrderService } from 'src/app/_services/order.service';
import { Order } from 'src/app/models/order';

@Component({
  selector: 'app-purchase-detail',
  templateUrl: './purchase-detail.component.html',
  styleUrls: ['./purchase-detail.component.scss']
})
export class PurchaseDetailComponent implements OnInit {

  diviceXs: boolean;
  diviceSm: boolean;

  purchasesList = [
    {
      _id: "001",
      purchaseDate: "26 / 03 / 2021",
      numberOfOrder: "1445243597",
      products: [
        {
          _id: "1jDJyQzNbaVcc7rXtlla",
          mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591207270/TuGessi/Desinfectantes/AP-JLA-EMC19000_ib8fep.jpg",
          name: "Jabón líquido antibacterial 19000 ml",
          reference: "AP-JLA-EMC19000",
          description: "Jabón líquido antibacterial para manos, en presentaciones de frutos rojos, frutos verdes, avena y neutro.  Producto con registro INVIMA.",
          price: "86900",
          pointsRevenue: "108",
          points: "9656",
          brand: "Berlhan"
        },
        {
          _id: "3YjGbb1gg496L1n6LyDn",
          mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591650938/TuGessi/Desinfectantes/AP-GAVIT-GLIC1000_t2pzl1.jpg",
          name: "Gel antibacterial vitapulita 1000 ml",
          reference: "AP-GAVIT-GLIC1000",
          description: "Gel antibacterial diseñado para dar limpieza instantánea a sus manos sin necesidad de enjuagar. posee propiedades humectantes.",
          price: "16900",
          pointsRevenue: "20",
          points: "1878",
          brand: "Berlhan"
        }
      ],
      shippingInformation: {
        state: "Antioquia",
        city: "Medellin",
        neighborhood: "La Milagrosa",
        address: "Calle 37 # 47 B 27",
        addressSpecification: "Apto: 9910 / torre 3 / Unid. torres de cataluña"
      },
      totalBillPesos: "103800",
      totalPoints: "19700",
      pointsGenerated: "128",
      paymentMethod: "Tarjeta debito - Bancolombia",
      freeShipping: true,
      paidWithPoints: false,
      costOfShipping: "7900"
    },
    {
      _id: "002",
      purchaseDate: "19 / 02 / 2021",
      numberOfOrder: "1445243597",
      products: [
        {
          _id: "cULBXIOxZvBVSY11Et26",
          mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591653193/TuGessi/Desinfectantes/AP-LDGER-AC3800_lpjsdj.jpg",
          name: "Germizan desinfectante 3800",
          reference: "AP-LDGER-AC3800",
          description: "Producto de gran poder bactericida y fungicida, diseñado para la desinfección de áreas y utensilios, y otras superficies no porosas, destruye las bacterias causantes del mal olor, elimina hongos y demás bacterias gram positivas y gram negativas. (Temporalmente sin IVA)",
          price: "86900",
          pointsRevenue: "24",
          points: "19700",
          brand: "Berlhan"
        }
      ],
      shippingInformation: {
        state: "Choco",
        city: "Quibdo",
        neighborhood: "La playa",
        address: "Calle 1 # 47 B 27",
        addressSpecification: "Al frente de la tienda pacho"
      },
      totalBillPesos: "86900",
      totalPoints: "11534",
      pointsGenerated: "24",
      paymentMethod: "Puntos",
      freeShipping: false,
      paidWithPoints: true,
      costOfShipping: "7900"
    },
    {
      _id: "003",
      purchaseDate: "08 / 12 / 2020",
      numberOfOrder: "1445243597",
      products: [
        {
          _id: "IeT9EJWCLLowyYiwvsFe",
          mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591653193/TuGessi/Desinfectantes/AP-LDGER-AC3800_lpjsdj.jpg",
          name: "Overol anti fluido para protección",
          reference: "AP-LDGER-AC3800",
          description: "Producto de gran poder bactericida y fungicida, diseñado para la desinfección de áreas y utensilios, y otras superficies no porosas, destruye las bacterias causantes del mal olor, elimina hongos y demás bacterias gram positivas y gram negativas. (Temporalmente sin IVA)",
          price: "19700",
          pointsRevenue: "24",
          points: "2189",
          brand: "TuGessi"
        }
      ],
      shippingInformation: {
        state: "Choco",
        city: "Quibdo",
        neighborhood: "La playa",
        address: "Calle 1 # 47 B 27",
        addressSpecification: "Al frente de la tienda pacho"
      },
      totalBillPesos: "19700",
      totalPoints: "2189",
      pointsGenerated: "24",
      paymentMethod: "Plata",
      freeShipping: false,
      paidWithPoints: false,
      costOfShipping: "8000"
    }
  ];

  orderDetails: Order;
  generatedPoints: number = 0;

  constructor(public firebaseAuthService: FirebaseAuthService, public mediaObserver: MediaObserver, private devicesService: DevicesService, private route: ActivatedRoute, private orderService: OrderService, public router: Router) {

    this.orderDetails = this.orderService.currentOrder;

    if (!this.orderDetails) {
      this.router.navigate(['/']);
    } else {
      this.calculaTeTotalPoints();
    }

    console.log("orderDetails", this.orderDetails);
    this.purchasesList = [
      {
        _id: "001",
        purchaseDate: "26 / 03 / 2021",
        numberOfOrder: "1445243597",
        products: [
          {
            _id: "1jDJyQzNbaVcc7rXtlla",
            mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591207270/TuGessi/Desinfectantes/AP-JLA-EMC19000_ib8fep.jpg",
            name: "Jabón líquido antibacterial 19000 ml",
            reference: "AP-JLA-EMC19000",
            description: "Jabón líquido antibacterial para manos, en presentaciones de frutos rojos, frutos verdes, avena y neutro.  Producto con registro INVIMA.",
            price: "86900",
            pointsRevenue: "108",
            points: "9656",
            brand: "Berlhan"
          },
          {
            _id: "3YjGbb1gg496L1n6LyDn",
            mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591650938/TuGessi/Desinfectantes/AP-GAVIT-GLIC1000_t2pzl1.jpg",
            name: "Gel antibacterial vitapulita 1000 ml",
            reference: "AP-GAVIT-GLIC1000",
            description: "Gel antibacterial diseñado para dar limpieza instantánea a sus manos sin necesidad de enjuagar. posee propiedades humectantes.",
            price: "16900",
            pointsRevenue: "20",
            points: "1878",
            brand: "Berlhan"
          }
        ],
        shippingInformation: {
          state: "Antioquia",
          city: "Medellin",
          neighborhood: "La Milagrosa",
          address: "Calle 37 # 47 B 27",
          addressSpecification: "Apto: 9910 / torre 3 / Unid. torres de cataluña"
        },
        totalBillPesos: "103800",
        totalPoints: "19700",
        pointsGenerated: "128",
        paymentMethod: "Tarjeta debito - Bancolombia",
        freeShipping: true,
        paidWithPoints: false,
        costOfShipping: "7900"
      },
      {
        _id: "002",
        purchaseDate: "19 / 02 / 2021",
        numberOfOrder: "1445243597",
        products: [
          {
            _id: "cULBXIOxZvBVSY11Et26",
            mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591653193/TuGessi/Desinfectantes/AP-LDGER-AC3800_lpjsdj.jpg",
            name: "Germizan desinfectante 3800",
            reference: "AP-LDGER-AC3800",
            description: "Producto de gran poder bactericida y fungicida, diseñado para la desinfección de áreas y utensilios, y otras superficies no porosas, destruye las bacterias causantes del mal olor, elimina hongos y demás bacterias gram positivas y gram negativas. (Temporalmente sin IVA)",
            price: "86900",
            pointsRevenue: "24",
            points: "19700",
            brand: "Berlhan"
          }
        ],
        shippingInformation: {
          state: "Choco",
          city: "Quibdo",
          neighborhood: "La playa",
          address: "Calle 1 # 47 B 27",
          addressSpecification: "Al frente de la tienda pacho"
        },
        totalBillPesos: "86900",
        totalPoints: "11534",
        pointsGenerated: "24",
        paymentMethod: "Puntos",
        freeShipping: false,
        paidWithPoints: true,
        costOfShipping: "7900"
      },
      {
        _id: "003",
        purchaseDate: "08 / 12 / 2020",
        numberOfOrder: "1445243597",
        products: [
          {
            _id: "IeT9EJWCLLowyYiwvsFe",
            mainPhoto: "https://res.cloudinary.com/dxagka8lm/image/upload/v1591653193/TuGessi/Desinfectantes/AP-LDGER-AC3800_lpjsdj.jpg",
            name: "Overol anti fluido para protección",
            reference: "AP-LDGER-AC3800",
            description: "Producto de gran poder bactericida y fungicida, diseñado para la desinfección de áreas y utensilios, y otras superficies no porosas, destruye las bacterias causantes del mal olor, elimina hongos y demás bacterias gram positivas y gram negativas. (Temporalmente sin IVA)",
            price: "19700",
            pointsRevenue: "24",
            points: "2189",
            brand: "TuGessi"
          }
        ],
        shippingInformation: {
          state: "Choco",
          city: "Quibdo",
          neighborhood: "La playa",
          address: "Calle 1 # 47 B 27",
          addressSpecification: "Al frente de la tienda pacho"
        },
        totalBillPesos: "19700",
        totalPoints: "2189",
        pointsGenerated: "24",
        paymentMethod: "Plata",
        freeShipping: false,
        paidWithPoints: false,
        costOfShipping: "8000"
      }
    ]
  }

  ngOnInit(): void {
    this.devicesService.dievice$.subscribe(res => {
      console.log("device", res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });

    // this.route.params.subscribe(params => {
    //   this.orderDetails = this.purchasesList.find(x => x._id == params['id'])
    // });
  }


  calculaTeTotalPoints(): void {
    this.orderDetails.orderDetail.forEach(product => {
      this.generatedPoints += product.pointsRevenue;
    });
  }

  goToProductView(productId: string) {
    this.router.navigate([{ outlets: { primary: ['product', productId], sidebar: ['product', productId] } }]);
  }

}
